import { render, staticRenderFns } from "./NoteComponent.vue?vue&type=template&id=1b31014c&"
import script from "./NoteComponent.vue?vue&type=script&lang=js&"
export * from "./NoteComponent.vue?vue&type=script&lang=js&"
import style0 from "./NoteComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports